import { GlobalAlert } from '@thoughtspot/global-alert';
import { translate as t } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum, userActionTypes, } from '@thoughtspot/metrics';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getOnlineDocUrl, isAdminModernExperienceEnabled, } from '@thoughtspot/session-service';
import React, { useMemo, useState } from 'react';
import { DependencyListObjectType, } from "../../../services/generated/graphql-types";
import { DATA_TEST_ID, GEO_CONFIG_HELPER_DOC_LINK, } from "../../../utils/chart-customization";
import { DependentsModal } from '../common/dependent-objects';
import { CustomRegionContainer } from './custom-region/custom-region.container';
import { CustomRegionList } from './custom-region-list';
import styles from './geomap.module.scss';
export const Geomap = ({ collectEvent, data, loading, dependentsData, fetchDependents, deleteCustomRegion, getCustomRegionList, currentOrgId, }) => {
    const [isCustomRegionContainerOpen, setIsCustomRegionContainerOpen,] = useState(false);
    const [selectedFileId, setSelectedFileId] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const [deleteInProgress, setDeleteInProgress] = useState(false);
    const [toastAlertMessage, setToastAlertMessage] = useState('');
    const handleOnDelete = (id, name) => {
        collectEvent(new UserAction(userActionTypeEnum.CLICK), {
            trackId: userActionTypes.DELETE_MAP.name,
        });
        setSelectedFileId(id);
        setSelectedFileName(name);
        setDeleteInProgress(true);
        fetchDependents([id], DependencyListObjectType.File);
    };
    const handleOnDeleteConfirmation = async () => {
        collectEvent(new UserAction(userActionTypeEnum.MAP_DELETED), {
            fileType: 'TopoJSON',
        });
        await deleteCustomRegion(selectedFileId, currentOrgId);
        setToastAlertMessage(t('customRegion.file.delete.toast.msg', [selectedFileName]));
        setDeleteInProgress(false);
        setSelectedFileId(null);
        getCustomRegionList();
    };
    const handleOnDeleteModalClose = () => {
        setDeleteInProgress(false);
    };
    const areDependentsPresent = !!dependentsData?.length;
    const handleOnCancellation = () => {
        setIsCustomRegionContainerOpen(false);
        setSelectedFileId(null);
        setSelectedFileName(null);
    };
    const handleOnUpdate = (name) => {
        setIsCustomRegionContainerOpen(false);
        if (selectedFileId) {
            setToastAlertMessage(t('customRegion.file.update.toast.msg', [name]));
        }
        else {
            setToastAlertMessage(t('customRegion.file.insert.toast.msg', [name]));
        }
        setSelectedFileId(null);
        getCustomRegionList();
    };
    const handleRowEdit = (id) => {
        fetchDependents([id], DependencyListObjectType.File);
        setIsCustomRegionContainerOpen(true);
        setSelectedFileId(id);
        collectEvent(new UserAction(userActionTypeEnum.CLICK), {
            trackId: userActionTypes.EDIT_MAP.name,
        });
    };
    const handleAddCustomRegion = () => {
        setIsCustomRegionContainerOpen(true);
        setSelectedFileId(null);
        collectEvent(new UserAction(userActionTypeEnum.CLICK), {
            trackId: userActionTypes.ADD_MAP.name,
        });
    };
    const warningDescription = useMemo(() => (React.createElement(Typography, { variant: "body-normal" },
        t('customRegion.file.dependency.modal.description'),
        React.createElement(Link, { "data-testid": DATA_TEST_ID.GEO_CONFIG_HELPER_DOC_LINK_TEST_ID, href: `${getOnlineDocUrl()}${GEO_CONFIG_HELPER_DOC_LINK}`, target: "_blank", rel: "noopener" }, t('helpLinkText')))), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Horizontal, { hAlignContent: isAdminModernExperienceEnabled() ? undefined : 'right', vAlignContent: "center", className: isAdminModernExperienceEnabled()
                ? styles.addMapBtnContainerModern
                : styles.addMapBtnContainer },
            isAdminModernExperienceEnabled() && (React.createElement(Typography, { variant: "body-normal", color: Colors.grayLight, noMargin: true }, t('adminSection.chartCustomization.geomaps.description'))),
            React.createElement(Button, { text: t('chartCustomization.geomaps.content.addMap'), tooltip: t('chartCustomization.geomaps.content.addMap'), type: "secondary", size: "m", backgroundType: "light", onClick: handleAddCustomRegion, "data-testid": "addMapPrimaryBtn" })),
        React.createElement(CustomRegionList, { data: data, handleRowEdit: handleRowEdit, handleOnDelete: handleOnDelete, loading: loading, addCustomRegion: handleAddCustomRegion, currentOrgId: currentOrgId }),
        isCustomRegionContainerOpen && (React.createElement(CustomRegionContainer, { selectedFileId: selectedFileId, isOpen: !loading && isCustomRegionContainerOpen, onCancellation: handleOnCancellation, onUpdate: handleOnUpdate, dependentsData: dependentsData, currentOrgId: currentOrgId })),
        deleteInProgress &&
            areDependentsPresent && (React.createElement(DependentsModal, { "data-testid": "DependenciesModalTestId", isModalOpen: true, onModalClose: handleOnDeleteModalClose, logicalData: dependentsData, title: t('customRegion.file.dependency.modal.title'), warningDescription: warningDescription })),
        React.createElement(Modal, { size: ModalSize.SMALL, title: t('customRegion.file.delete.modal.title'), isOpen: !loading && deleteInProgress && !areDependentsPresent, confirmButton: {
                text: t('alert.delete.text'),
                onConfirm: handleOnDeleteConfirmation,
                isLoading: loading,
                isDisabled: loading,
            }, dismissButton: {
                text: t('Cancel'),
                onClick: handleOnDeleteModalClose,
            } },
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "body-normal" }, t('customRegion.file.delete.modal.description', [
                    selectedFileName,
                ])))),
        React.createElement(GlobalAlert.Toast, { isVisible: !!toastAlertMessage, message: toastAlertMessage, autoHide: true, onClose: () => {
                setToastAlertMessage('');
            } })));
};
//# sourceMappingURL=geomap.js.map